<template>
  <vue-modal :ref="modalId" :name="modalId" :width="modalWidth" height="auto" >
    <div id="preview-locale-modal" class="modal-content" style="overflow: auto;">
      <div class="modal-header">
        <h5 class="modal-title">{{ modalTitle }}</h5>
        <button type="button" class="close" @click="closeModal">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body"> You are about to leave your current view. Be sure to click the "Save as Card" button to save any changes you may have made.</div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary ml-4" @click="goToExploreForProfileTable">Go</button>
        <button type="button" class="btn btn-primary ml-4" @click="closeModal">Cancel</button>
      </div>
    </div>
  </vue-modal>
</template>

<script>
import ViewMixins from "../mixins/ViewMixins.vue";

export default {
  name: "ExploreNavigationModal",
  mixins: [ViewMixins],
  components: {},
  data() {
    return {
      modalReturnMessage: "",
      needType: "",
      needNumber: 0,
      clientChartId: 0,
    };
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    goToExploreForProfileTable() {
      let path = '/analytics/from-profile/explore/true/'+this.clientChartId+'/'+this.needType+'/'+this.needNumber;
      this.$router.replace({ path: path });
    },
    closeModal: function(){
      if (this.$refs[this.modalId] != null) {
        this.$refs[this.modalId].visible = false;
      }
    },      
  },
  watch: {},
  props: {
    modalId: {
      type: String,
      default: "preview-locale",
    },
    modalTitle: {
      type: String,
      default: "Explore",
    },
    modalContent: {
      type: String,
      default: "",
    },
    modalWidth: {
      type: Number,
      default: 368
    },
  }
};
</script>
